/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiDefApiConfiguration } from '../api-def-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authBeforeAuthUserCreate } from '../fn/auth/auth-before-auth-user-create';
import { AuthBeforeAuthUserCreate$Params } from '../fn/auth/auth-before-auth-user-create';
import { authCreateUserWithEmailAndPassword } from '../fn/auth/auth-create-user-with-email-and-password';
import { AuthCreateUserWithEmailAndPassword$Params } from '../fn/auth/auth-create-user-with-email-and-password';
import { authCsrfToken } from '../fn/auth/auth-csrf-token';
import { AuthCsrfToken$Params } from '../fn/auth/auth-csrf-token';
import { authCustomToken } from '../fn/auth/auth-custom-token';
import { AuthCustomToken$Params } from '../fn/auth/auth-custom-token';
import { authMe } from '../fn/auth/auth-me';
import { AuthMe$Params } from '../fn/auth/auth-me';
import { authSessionLogin } from '../fn/auth/auth-session-login';
import { AuthSessionLogin$Params } from '../fn/auth/auth-session-login';
import { authSessionLogout } from '../fn/auth/auth-session-logout';
import { AuthSessionLogout$Params } from '../fn/auth/auth-session-logout';
import { ApiDefProjectData } from '../models/api-def-project-data';
import { ApiDefUserData } from '../models/api-def-user-data';


/**
 * Authentication and session management
 */
@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiDefApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authCreateUserWithEmailAndPassword()` */
  static readonly AuthCreateUserWithEmailAndPasswordPath = '/auth/createUserWithEmailAndPassword';

  /**
   * Create a new user with email and password.
   *
   * Create a new user with email and password
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authCreateUserWithEmailAndPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authCreateUserWithEmailAndPassword$Response(params: AuthCreateUserWithEmailAndPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'userData'?: ApiDefUserData;
}>> {
    return authCreateUserWithEmailAndPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new user with email and password.
   *
   * Create a new user with email and password
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authCreateUserWithEmailAndPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authCreateUserWithEmailAndPassword(params: AuthCreateUserWithEmailAndPassword$Params, context?: HttpContext): Observable<{
'userData'?: ApiDefUserData;
}> {
    return this.authCreateUserWithEmailAndPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'userData'?: ApiDefUserData;
}>): {
'userData'?: ApiDefUserData;
} => r.body)
    );
  }

  /** Path part for operation `authBeforeAuthUserCreate()` */
  static readonly AuthBeforeAuthUserCreatePath = '/auth/beforeAuthUserCreate';

  /**
   * Process a beforeAuthUserCreate blocking event.
   *
   * Triggered by Firebase Identity Platform just before a new user is created. The request must contain the Google-signed Identity Platform blocking-event JWT. The service verifies its signature, issuer, exact configured function audience, lifetime, beforeCreate event identity, and embedded user record. No token or user payload is logged. The endpoint currently returns no user modifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authBeforeAuthUserCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authBeforeAuthUserCreate$Response(params: AuthBeforeAuthUserCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Modified or default display name.
 */
'displayName'?: string;

/**
 * Modified profile picture URL.
 */
'photoURL'?: string;

/**
 * Custom claims to persist with the user.
 */
'customClaims'?: {
};

/**
 * Updated email verification flag.
 */
'emailVerified'?: boolean;

/**
 * Updated disabled state.
 */
'disabled'?: boolean;
}>> {
    return authBeforeAuthUserCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Process a beforeAuthUserCreate blocking event.
   *
   * Triggered by Firebase Identity Platform just before a new user is created. The request must contain the Google-signed Identity Platform blocking-event JWT. The service verifies its signature, issuer, exact configured function audience, lifetime, beforeCreate event identity, and embedded user record. No token or user payload is logged. The endpoint currently returns no user modifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authBeforeAuthUserCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authBeforeAuthUserCreate(params: AuthBeforeAuthUserCreate$Params, context?: HttpContext): Observable<{

/**
 * Modified or default display name.
 */
'displayName'?: string;

/**
 * Modified profile picture URL.
 */
'photoURL'?: string;

/**
 * Custom claims to persist with the user.
 */
'customClaims'?: {
};

/**
 * Updated email verification flag.
 */
'emailVerified'?: boolean;

/**
 * Updated disabled state.
 */
'disabled'?: boolean;
}> {
    return this.authBeforeAuthUserCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * Modified or default display name.
 */
'displayName'?: string;

/**
 * Modified profile picture URL.
 */
'photoURL'?: string;

/**
 * Custom claims to persist with the user.
 */
'customClaims'?: {
};

/**
 * Updated email verification flag.
 */
'emailVerified'?: boolean;

/**
 * Updated disabled state.
 */
'disabled'?: boolean;
}>): {

/**
 * Modified or default display name.
 */
'displayName'?: string;

/**
 * Modified profile picture URL.
 */
'photoURL'?: string;

/**
 * Custom claims to persist with the user.
 */
'customClaims'?: {
};

/**
 * Updated email verification flag.
 */
'emailVerified'?: boolean;

/**
 * Updated disabled state.
 */
'disabled'?: boolean;
} => r.body)
    );
  }

  /** Path part for operation `authSessionLogin()` */
  static readonly AuthSessionLoginPath = '/auth/sessionLogin';

  /**
   * Login to the session.
   *
   * Login to the session
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authSessionLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authSessionLogin$Response(params: AuthSessionLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'userData'?: ApiDefUserData;
}>> {
    return authSessionLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * Login to the session.
   *
   * Login to the session
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authSessionLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authSessionLogin(params: AuthSessionLogin$Params, context?: HttpContext): Observable<{
'userData'?: ApiDefUserData;
}> {
    return this.authSessionLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'userData'?: ApiDefUserData;
}>): {
'userData'?: ApiDefUserData;
} => r.body)
    );
  }

  /** Path part for operation `authSessionLogout()` */
  static readonly AuthSessionLogoutPath = '/auth/sessionLogout';

  /**
   * Logout from the session.
   *
   * Logout from the session
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authSessionLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  authSessionLogout$Response(params?: AuthSessionLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Status of the logout operation
 */
'status'?: 'success' | 'error';

/**
 * Message providing additional information about the logout operation
 */
'message'?: string;
}>> {
    return authSessionLogout(this.http, this.rootUrl, params, context);
  }

  /**
   * Logout from the session.
   *
   * Logout from the session
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authSessionLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authSessionLogout(params?: AuthSessionLogout$Params, context?: HttpContext): Observable<{

/**
 * Status of the logout operation
 */
'status'?: 'success' | 'error';

/**
 * Message providing additional information about the logout operation
 */
'message'?: string;
}> {
    return this.authSessionLogout$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * Status of the logout operation
 */
'status'?: 'success' | 'error';

/**
 * Message providing additional information about the logout operation
 */
'message'?: string;
}>): {

/**
 * Status of the logout operation
 */
'status'?: 'success' | 'error';

/**
 * Message providing additional information about the logout operation
 */
'message'?: string;
} => r.body)
    );
  }

  /** Path part for operation `authMe()` */
  static readonly AuthMePath = '/auth/me';

  /**
   * Get user information.
   *
   * Retrieve the current user's information
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  authMe$Response(params?: AuthMe$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'userData'?: ApiDefUserData;
'projectData'?: ApiDefProjectData;
}>> {
    return authMe(this.http, this.rootUrl, params, context);
  }

  /**
   * Get user information.
   *
   * Retrieve the current user's information
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authMe(params?: AuthMe$Params, context?: HttpContext): Observable<{
'userData'?: ApiDefUserData;
'projectData'?: ApiDefProjectData;
}> {
    return this.authMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'userData'?: ApiDefUserData;
'projectData'?: ApiDefProjectData;
}>): {
'userData'?: ApiDefUserData;
'projectData'?: ApiDefProjectData;
} => r.body)
    );
  }

  /** Path part for operation `authCsrfToken()` */
  static readonly AuthCsrfTokenPath = '/auth/csrfToken';

  /**
   * Get CSRF token in the cookie.
   *
   * Get CSRF token in the cookie
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authCsrfToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  authCsrfToken$Response(params?: AuthCsrfToken$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Status of the CSRF token retrieval operation
 */
'status'?: 'success';
}>> {
    return authCsrfToken(this.http, this.rootUrl, params, context);
  }

  /**
   * Get CSRF token in the cookie.
   *
   * Get CSRF token in the cookie
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authCsrfToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authCsrfToken(params?: AuthCsrfToken$Params, context?: HttpContext): Observable<{

/**
 * Status of the CSRF token retrieval operation
 */
'status'?: 'success';
}> {
    return this.authCsrfToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * Status of the CSRF token retrieval operation
 */
'status'?: 'success';
}>): {

/**
 * Status of the CSRF token retrieval operation
 */
'status'?: 'success';
} => r.body)
    );
  }

  /** Path part for operation `authCustomToken()` */
  static readonly AuthCustomTokenPath = '/auth/customToken';

  /**
   * Create a custom token.
   *
   * Create a custom token for authentication
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authCustomToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  authCustomToken$Response(params?: AuthCustomToken$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Custom token for authentication
 */
'customToken'?: string;
}>> {
    return authCustomToken(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a custom token.
   *
   * Create a custom token for authentication
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authCustomToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authCustomToken(params?: AuthCustomToken$Params, context?: HttpContext): Observable<{

/**
 * Custom token for authentication
 */
'customToken'?: string;
}> {
    return this.authCustomToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * Custom token for authentication
 */
'customToken'?: string;
}>): {

/**
 * Custom token for authentication
 */
'customToken'?: string;
} => r.body)
    );
  }

}
